/*jshint strict: false */
(
    function (window, document, $, _, undefined) {
        function addPostalZipValidation() {
            var code = $('select#country').find(':selected').data('abbr').toLowerCase(),
                postalZipInput = $('input#postalCode');

            if (code === 'ca') {
                postalZipInput.rules(
                    'add',
                    {
                        postalCodeCA: true
                    }
                );
                postalZipInput.rules('remove', 'zipcodeUS');
                postalZipInput.attr('placeholder','Postal Code*');
            } else if (code === 'us') {
                postalZipInput.rules(
                    'add',
                    {
                        zipcodeUS: true
                    }
                );
                postalZipInput.rules('remove', 'postalCodeCA');
                postalZipInput.attr('placeholder','Zip Code*');
            }
        }

        $(document).ready(
            function () {
                window.bsCustomFileInput.init();
                $('#registrationForm').validate(window.validatorOptions);

                $('select#country').on('change.one-health', addPostalZipValidation);

                addPostalZipValidation();
            }
        );
    }
)(window, document, window.jQuery, window._);
